import { Can } from "../../../../../casl/Can";
import { AppAvatar, AppBox, AppIconButton, AppPaper, AppTitle } from "../../../../../commons/components";
import IconPersonDelete from "../../../../../commons/components/icons/person-delete";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { IFootballTeamManager } from "../../../../../commons/models/football/interface/i-football-team-manager";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";
import { useAppSelector } from "../../../../../hooks/app";

interface ManagerCardProps {
  withShadow?: boolean;
  managerInfo: IFootballTeamManager;
  onPlayerRemove: (manager: IFootballTeamManager) => void;
}

export default function TeamManagerCard({ managerInfo, withShadow, onPlayerRemove }: ManagerCardProps) {
  const { teamInfo } = useAppSelector((state) => state.footballManageTeam);
  return (
    <AppPaper padding="xs" shadow={withShadow ? "xs" : "none"}>
      <AppBox justifyContent="space-between" alignItems="center">
        <AppBox gap="xs" alignItems="center">
          <AppAvatar username={managerInfo.fullName || ""} src={managerInfo.avatar || ""} size="md" />
          <AppBox flexDirection="column">
            <AppBox alignItems="center" gap="2xs">
              <AppTitle as="h6">{toTitleCase(managerInfo.fullName)}</AppTitle>
            </AppBox>
          </AppBox>
        </AppBox>
        <Can I={RolePolicyActionEnum.DELETE} this={teamInfo}>
          <AppIconButton
            variant="light"
            color="danger"
            onClick={() => {
              onPlayerRemove(managerInfo);
            }}
            icon={<IconPersonDelete />}
          />
        </Can>
      </AppBox>
    </AppPaper>
  );
}
